<template>
    <card-normal v-if="templateInfo" :class="componentClasses">
        <flex-container :gap="Size.xl">
            <flex-container
                :screen-sizes="{ tablet: 1 }"
            >
                <template-icon :icon="templateInfo.icon" />
            </flex-container>

            <flex-container :screen-sizes="{ tablet: 9 }">
                <flex-container :gap="Size.sm">
                    <flex-container
                        justify-content="space-between"
                        align-items="center"
                        no-wrap
                    >
                        <text-decorator
                            :size="FontSize.md"
                            bold
                            style="line-height: 1.4rem"
                        >
                            {{ props.template.name }}
                        </text-decorator>

                        <template-price-chip small :price="templateInfo.price" />
                    </flex-container>

                    <text-decorator :size="FontSize.xs" style="line-height: 1.4rem">
                        {{ templateInfo.shortDescription }}
                    </text-decorator>
                </flex-container>
            </flex-container>
        </flex-container>
    </card-normal>
</template>

<script setup lang="ts">
    import type { FlowTemplate } from '@keyvue/one-api-client';
    import { FontSize, TextDecorator, FlexContainer, CardNormal, Size } from '@keyvue/one-ui';
    import TemplatePriceChip from '@/flow/template/components/TemplatePriceChip.vue';
    import { computed } from 'vue';
    import TemplateIcon from '@/flow/template/components/TemplateIcon.vue';

    interface Props {
        template: FlowTemplate,
        active: boolean,
    }

    const props = defineProps<Props>();

    const componentClasses = computed(() => ({
        'template-info-card': true,
        'template-info-card--active': props.active,
    }));

    const templateInfo = computed(() => props.template.templateInfo);
</script>

<style scoped lang="scss">
.template-info-card {
    user-select: none;
    cursor: pointer;
    will-change: tranform;
    transition: transform .2s ease-in-out;

    .text-decorator {
        transition: none;
    }

    &--active {
        background-color: var(--theme-colors-default--primary) !important;
        color: white;
    }

    &:hover {
        transform: scale(1.03);
    }
}
</style>
